/**
 * When the in-session agent loader (ApiLoader) is visible, suppress the
 * global HTTP overlay so only one spinner appears.
 */

let agentOverlayActive = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function setAgentLoadingOverlayActive(active: boolean): void {
  if (agentOverlayActive === active) return;
  agentOverlayActive = active;
  emit();
}

export function getAgentLoadingOverlayActive(): boolean {
  return agentOverlayActive;
}

export function subscribeAgentLoadingOverlay(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}
